import { isEqual } from "lodash";
import { useEffect, useState } from "react";

import { useIsCurrentUserPermittedTo } from "../helpers/use_is_permitted_to";
import { AutoAllocationSettings, PermissionRule } from "../types";
import { ApiRoute } from "../utilities/routes";

const useAutoAllocationSettings = () => {
  const isPermittedTo = useIsCurrentUserPermittedTo();

  const isAuditAdmin = isPermittedTo(PermissionRule.AuditAdmin);

  const [autoAllocationSettings, setAutoAllocationSettings] = useState<AutoAllocationSettings>();

  const fetchAutoAllocationSettings = () => {
    // @ts-ignore
    $.ajax({
      url: ApiRoute("/api/auto_allocation_settings"),
      api_version: 2
    }).then((resp) => {
      if (!isEqual(resp, autoAllocationSettings)) {
        setAutoAllocationSettings(resp);
      }
    });
  };

  const setAlwaysAllocate = (value) => {
    // @ts-ignore
    $.ajax({
      url: ApiRoute(`/api/auto_allocation_settings/?always_on=${value}`),
      method: "PUT",
      api_version: 2
    }).then((resp) =>
      setAutoAllocationSettings((prev) => ({ ...prev, always_on: resp.always_on } as AutoAllocationSettings))
    );
  };

  useEffect(() => {
    if (!isAuditAdmin) {
      return; //Avoid calling if 422 is guaranteed
    }

    if (!autoAllocationSettings) {
      fetchAutoAllocationSettings();
    }
    const interval = setInterval(fetchAutoAllocationSettings, 5000);
    return () => {
      clearInterval(interval);
    };
  }, [autoAllocationSettings]);

  return { ...autoAllocationSettings, setAlwaysAllocate };
};

export default useAutoAllocationSettings;
